"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CartIconSVG;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CartIconSVG(_ref) {
  var icon = _ref.icon,
      color = _ref.color;

  // const icon = props.icon || 'bag'
  // const color = props.color || '#000'

  var icons = {
    bag: _react2.default.createElement(
      "svg",
      {
        viewBox: "0 0 18 16",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("path", { d: "M14 5A5 5 0 0 0 4 5", id: "a" }),
        _react2.default.createElement(
          "mask",
          { id: "b", x: "0", y: "0", width: "10", height: "5", fill: "#fff" },
          _react2.default.createElement("use", { xlinkHref: "#a" })
        )
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement("use", { stroke: color, mask: "url(#b)", strokeWidth: "2", xlinkHref: "#a" }),
        _react2.default.createElement("path", { fill: color, d: "M0 4h18l-3.033 12H3z" })
      )
    ),
    bagOutline: _react2.default.createElement(
      "svg",
      {
        viewBox: "0 0 18 16",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("path", { id: "a", d: "M0 4h18l-3.033 12H3z" }),
        _react2.default.createElement(
          "mask",
          { id: "c", x: "0", y: "0", width: "18", height: "12", fill: "#fff" },
          _react2.default.createElement("use", { xlinkHref: "#a" })
        ),
        _react2.default.createElement("path", { d: "M14 5A5 5 0 0 0 4 5", id: "b" }),
        _react2.default.createElement(
          "mask",
          { id: "d", x: "0", y: "0", width: "10", height: "10", fill: "#fff" },
          _react2.default.createElement("use", { xlinkHref: "#b" })
        )
      ),
      _react2.default.createElement(
        "g",
        { strokeWidth: "2", stroke: color, fill: "none", fillRule: "evenodd" },
        _react2.default.createElement("use", { mask: "url(#c)", xlinkHref: "#a" }),
        _react2.default.createElement("use", { mask: "url(#d)", xlinkHref: "#b" })
      )
    ),
    cart: _react2.default.createElement(
      "svg",
      {
        viewBox: "0 0 19 16",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement("circle", { id: "a", cx: "7.5", cy: "14.5", r: "1.5" }),
        _react2.default.createElement(
          "mask",
          { id: "c", x: "0", y: "0", width: "3", height: "3", fill: "#fff" },
          _react2.default.createElement("use", { xlinkHref: "#a" })
        ),
        _react2.default.createElement("circle", { id: "b", cx: "15.5", cy: "14.5", r: "1.5" }),
        _react2.default.createElement(
          "mask",
          { id: "d", x: "0", y: "0", width: "3", height: "3", fill: "#fff" },
          _react2.default.createElement("use", { xlinkHref: "#b" })
        )
      ),
      _react2.default.createElement(
        "g",
        { stroke: color, fill: "none", fillRule: "evenodd" },
        _react2.default.createElement("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M.513.539L4.052.512l2.488 11 9.95.006"
        }),
        _react2.default.createElement("path", {
          d: "M18.482 2.048l-1.056 6.435-11.57.019-1.443-6.486c3.364-.007 14.069.032 14.069.032z",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          fill: color
        }),
        _react2.default.createElement("use", { mask: "url(#c)", strokeWidth: "2", xlinkHref: "#a" }),
        _react2.default.createElement("use", { mask: "url(#d)", strokeWidth: "2", xlinkHref: "#b" })
      )
    ),
    cartOutline: _react2.default.createElement(
      "svg",
      { viewBox: "0 0 19 16", xmlns: "http://www.w3.org/2000/svg" },
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement("path", {
          stroke: color,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M.513.539L4.052.512l2.488 11 9.95.006"
        }),
        _react2.default.createElement("path", {
          d: "M18.482 2.048l-1.056 6.435-11.57.019-1.443-6.486c3.364-.007 14.069.032 14.069.032z",
          stroke: color,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }),
        _react2.default.createElement("path", {
          d: "M7.5 13c-.836 0-1.5.664-1.5 1.5S6.664 16 7.5 16 9 15.336 9 14.5 8.336 13 7.5 13zm0 2.143a.631.631 0 0 1-.643-.643c0-.364.279-.643.643-.643s.643.279.643.643-.3.643-.643.643zm6.643-.643c0 .836.664 1.5 1.5 1.5s1.5-.664 1.5-1.5-.664-1.5-1.5-1.5-1.5.664-1.5 1.5zm1.5.643A.631.631 0 0 1 15 14.5c0-.364.279-.643.643-.643s.643.279.643.643-.3.643-.643.643z",
          fill: color
        })
      )
    )
  };

  return icons[icon] || null;
}